const socialGroupStore = {
	state: {
		// groups
		activeSocialGroup: {
			id: 1001,
			name: `Love My Dog Club`,
			access: `CM`,
		},
		groupMembers: null,
		clubCreator: false,
		hasUnsavedChanges: false,
		tempActiveGroup: {
			id: 1001,
			name: `Love My Dog Club`,
			access: `CM`,
		},
		postContent: null,
	},
	mutations: {
		// groups
		setActiveGroup(state, group) {
			// check if there is unsave changes
			if (state.hasUnsavedChanges) {
				state.tempActiveGroup = group
			} else {
				state.activeSocialGroup = group

				//check if tempActiveGroup is updated.
				if (state.tempActiveGroup !== group) {
					state.tempActiveGroup = group
				}
			}
		},
		setGroupMembers(state, groupMembers) {
			state.groupMembers = groupMembers
		},

		setClubCreator(state, status) {
			state.clubCreator = status
		},
		resetActiveGroup(state) {
			state.activeSocialGroup = {
				id: 1001,
				name: `Love My Dog Club`,
				access: `CM`,
			}

			state.hasUnsavedChanges = false
			state.tempActiveGroup = state.activeSocialGroup
		},
		setHasUnsavedChanges(state, hasUnsavedChanges) {
			state.hasUnsavedChanges = hasUnsavedChanges
		},
		setPostContent(state, postContent) {
			state.postContent = postContent
		},
	},
	getters: {
		getActiveGroup(state) {
			return state.activeSocialGroup
		},
		getGroupMembers(state) {
			return state.groupMembers
		},
		getClubCreator(state) {
			return state.clubCreator
		},
		getTempActiveGroup(state) {
			return state.tempActiveGroup
		},
		getHasUnsavedChanges(state) {
			return state.hasUnsavedChanges
		},
		getPostContent(state) {
			return state.postContent
		},
	},
}

export default socialGroupStore
